import React, { useState } from "react";
import { DatePicker } from 'antd';
import { SkeletonLine } from "../../Views/UI/skeletonLoader";
import dayjs from 'dayjs';

//Plugins
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";

const { RangePicker } = DatePicker;

const TotalVisits = ({ totalVisits, isLoading, dates, setDates, disableStartDate }) => {

  const CustomTooltip = ({ active, payload }) => {
    if (!(active && payload && payload.length)) return null;
    return (
      <div className="dark-tooltip">
        <p className="title">Date:</p>
        <p className="text">{payload[0].payload.unixdate}</p>
        <hr />
        <p className="title">Total Visits:</p>
        <p className="text">{payload[0].payload.totalVisits}</p>
      </div>
    )
  }

  return (
    <div>
      <div className="card">
        <div className="card-header card-header-icon" data-background-color='red'>
          <i className="material-icons">language</i>
        </div>
        <div className="card-content">
          <div className="col">
            <h4 className="card-title">Total Visitors</h4>
            <div className="card-content">
              <RangePicker
                value={[dates.startDate, dates.endDate]}
                onChange={(date, dateString) => setDates({ startDate: dayjs(dateString[0]), endDate: dayjs(dateString[1]) })}
                allowClear={false}
                size={"middle"}
                bordered={"false"}
                format={"YYYY-MM-DD"}
                disabledDate={(current) => current && current < dayjs(disableStartDate)}
                separator={<i className="material-icons">arrow_right_alt</i>}
              />
            </div>
          </div>
        </div>
        <div className="card-content">
          {!isLoading ?
            <div className="row">
              <div className={`col-md-9 line-chart-container`}>
                <div className='col-md-12'>
                  <div className='charts'>
                    <ResponsiveContainer width="100%" height={400}>
                      <LineChart data={totalVisits}>
                        <Line
                          type="monotone"
                          dataKey="totalVisits"
                          stroke="#0093B2"
                          activeDot={{ r: 4 }}
                        />
                        <YAxis dataKey="totalVisits" />
                        <XAxis dataKey="unixdate" />
                        <Tooltip content={<CustomTooltip />} />
                        {/* <Legend /> */}
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </div>
            :
            <div className="row">
              <div className="col-md-12">
                <div className="skeleton skeleton-chart">
                  <SkeletonLine style={{ height: '50%', width: '4%' }} />
                  <SkeletonLine style={{ height: '45%', width: '4%' }} />
                  <SkeletonLine style={{ height: '20%', width: '4%' }} />
                  <SkeletonLine style={{ height: '100%', width: '4%' }} />
                  <SkeletonLine style={{ height: '50%', width: '4%' }} />
                  <SkeletonLine style={{ height: '45%', width: '4%' }} />
                  <SkeletonLine style={{ height: '20%', width: '4%' }} />
                  <SkeletonLine style={{ height: '100%', width: '4%' }} />
                  <SkeletonLine style={{ height: '50%', width: '4%' }} />
                  <SkeletonLine style={{ height: '45%', width: '4%' }} />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default TotalVisits;
